<template>
	<div>
		<div class="bio-pane active">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<label>日期 <el-date-picker size="small" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" v-model="filter.date" @change="handleFilter(3,1, $event)"></el-date-picker></label>
					<div style="display: inline-block;">
						数据源
						<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.dataType" @change="handleFilter(3,2, $event)">
							<el-option v-for="item in sourceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</div>
				</el-form>
			</div>
			
			<div class="pane-mode table-wrap" :class="{active: viewMode == 1}">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" v-if="currentTab===6">
					<el-table-column prop="lisDate" label="测量时间" show-overflow-tooltip min-width="120"></el-table-column>
					<el-table-column label="丙肝抗体(抗HCV)" min-width="120">
						<template slot-scope="scope"><span class="lv" :class="['lv'+ scope.row.level]">{{ scope.row.itemResult ? scope.row.itemResult : '未测量'}}</span>{{scope.row.itemRange ? '('+scope.row.itemRange+')' : ''}}</template>
					</el-table-column>
					<el-table-column label="结果" min-width="120">
						<template slot-scope="scope"><span class="lv" :class="['lv'+scope.row.level]">{{ scope.row.itemTip ? scope.row.itemTip : '未测量'}}</span></template>
					</el-table-column>
					<el-table-column prop="dataType" label="数据源" width="100"></el-table-column>
				</el-table>
                <el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" v-if="currentTab==7">
					<el-table-column prop="lisDate" label="测量时间" show-overflow-tooltip min-width="120"></el-table-column>
					<el-table-column label="HCV-RNA(IU/ml)" min-width="120">
						<template slot-scope="scope">
							<span class="lv" :class="['lv'+ scope.row.level]">{{ scope.row.itemResult ? scope.row.itemResult : '未测量'}}</span>{{scope.row.itemRange ? '('+scope.row.itemRange+')' : ''}}</template>
					</el-table-column>
					<el-table-column prop="dataType" label="数据源" width="100"></el-table-column>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>				
			</div>
		</div>
	</div>	
</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import dayjs from 'dayjs';

export default {
  mixins: [mixin],
	props: {
		patientId: { required: true },
        currentTab:{ require:true }
	},
	data(){
		return {
			noSidebar: true,
			sourceList:[],
			filter:{
				patientId: 0,
				dataType: '',
				type:'',
				measuringTimeStart: '',
				measuringTimeEnd: '',
				date: [],
				pageNumber: 1,
				pageSize: 30
			},
			viewMode: 1,
			isFormActive: false,
			form: {
				patientId: 0,
				measuringTime: undefined,
				itemResult: undefined,
				recordId: undefined,
				dataType: 3,
				dataId: 0,
				// id: 0,
			},
			list: {pageSize: 30, pageCount: 50, total: 300,data: []},	
		}
	},
    watch:{
        currentTab:{
            immediate:true,
            handler(val){
                this.loadList(val);
				this.filter.dataType=''
				this.filter.date=[];
            }
        }
    },
	created() {
		this.filter.patientId = this.patientId;
		this.loadList();
		// 获取 来源下拉
		api.getPatientBioSourceType({}).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.sourceList = res.data;
			}
		});
	},
	methods: {
		async loadList(){
			const filter = JSON.parse(JSON.stringify(this.filter));
			filter.date = undefined;
			if(this.currentTab==6){
				let res = await api.getPatientHcvList(filter);
				if (res.code == 1000 && res.data) {
					if (res.data) {
						res.data.forEach((item)=>{
							item.level = this.getLevel(1,item.itemTip);
						})
						this.list.total = +res.total;
						this.list.current = this.filter.pageNumber;
						this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);					
						this.list.data = res.data;
					}
				}
			} else if(this.currentTab==7){
				let res = await api.getPatienthcvRnaList(filter);
				if (res.code == 1000 && res.data) {
					if (res.data) {
						res.data.forEach((item)=>{
							item.level = this.getLevel(1,item.itemTip);
						})
						this.list.total = +res.total;
						this.list.current = this.filter.pageNumber;
						this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);					
						this.list.data = res.data;
					}
				}
			}
			
			

		},
		// 求平均值
		MathAvg(arr) {
			return (arr.reduce((pre, cur) => pre + cur) / arr.length).toFixed(1);
		},
		handleMode(key) {
			this.viewMode = key;
		},
		handleFilter(key, val) {
			if(val == 1){
				// 时间筛选
				if (this.filter.date) {
					this.filter.measuringTimeStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
					this.filter.measuringTimeEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
				} else {
					this.filter.measuringTimeStart = '';
					this.filter.measuringTimeEnd = '';						
				}
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},
		getLevel(v,key){
			if(v != 0){
				switch(key){
					case '高': return 4;
					case '低': return 1;
					case '阳性': return 4;
					default : return 0;
				}
			}
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},		
	}
}	
</script>
